// Volcano tile shading for the land-tile program (TerrainTiles). No new
// vertex attribute: the tile program is at the driver's attribute limit, so
// the volcano code rides in the high bits of the existing `aTone.z` channel
// (tileGeometry's `_vRiverEdge`, a flat int): bits 0..5 = river-edge mask,
// bits 6..7 = volcano tile code (0 none, 1 dormant, 2 active, 3 erupting;
// volcano.ts `volcanoTileCode`), bit 8 = landlocked-wall tile (sea/wallStyle.ts).
// 63 + 3*64 + 256 = 511, exact in a float. No extra
// varying either: the code is read from the existing `_vRiverEdge`.

/** Snow multiplier by volcano code: none 1, dormant 0.3 (lower cap), lit 0. */
export const VOLCANO_SNOW_GLSL = /* glsl */ `
          float _vcode = float((_vRiverEdge >> 6) & 3);
          float _wall = float((_vRiverEdge >> 8) & 1);
          float _snowK = _wall > 0.5 ? 0.0 : (_vcode < 0.5 ? 1.0 : (_vcode < 1.5 ? 0.3 : 0.0));`;

/**
 * Ash-dark flanks over the whole tile top and, on lit volcanoes, glowing
 * fissures in a ring around the cone base (the cone mesh itself is drawn by
 * Volcanoes.tsx). Runs after the snow pass so it wins over the strata/dirt.
 */
export const VOLCANO_TINT_GLSL = /* glsl */ `
          if (_wall > 0.5) {
            // Landlocked wall (sea/wallStyle): dark basalt, no snow, cold shadow tint.
            diffuseColor.rgb *= vec3(0.46, 0.45, 0.5);
          }
          if (_vcode > 0.5) {
            float _lum = dot(diffuseColor.rgb, vec3(0.299, 0.587, 0.114));
            vec3 _ash = vec3(0.06, 0.053, 0.05) + _lum * vec3(0.2, 0.17, 0.15);
            diffuseColor.rgb = mix(diffuseColor.rgb, _ash, 0.82);
            float _lit = clamp(_vcode - 1.0, 0.0, 2.0);
            float _rl = length(_vLocal.xz);
            float _an = atan(_vLocal.z, _vLocal.x);
            float _vein = abs(sin(_an * 5.0 + _rl * 9.0 + sin(_rl * 17.0 + _an * 3.0) * 1.6));
            float _fis = (1.0 - smoothstep(0.0, 0.16, _vein))
                       * smoothstep(0.5, 0.62, _rl) * (1.0 - smoothstep(0.78, 0.9, _rl));
            float _pul = 0.72 + 0.28 * sin(uRiverTime * 7.0 + _an * 3.0 + _rl * 5.0);
            // dormant: faint breathing red; active 0.7; erupting 1.3
            float _amt = _lit < 0.5 ? 0.12 : (_lit < 1.5 ? 0.7 : 1.3);
            diffuseColor.rgb += vec3(1.0, 0.33, 0.05) * _fis * _amt * _pul;
          }`;
